import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAuth, browserLocalPersistence, indexedDBLocalPersistence, inMemoryPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBwQ345FJJmGzd6USvl0d7xtunKI4Nxqkg",
  authDomain: "chore-champ-d474f.firebaseapp.com",
  projectId: "chore-champ-d474f",
  storageBucket: "chore-champ-d474f.firebasestorage.app",
  messagingSenderId: "994362844767",
  appId: "1:994362844767:web:49534eec22f716a8f39dea"
};

const app = initializeApp(firebaseConfig);

// ✅ Firestore
export const db = getFirestore(app);

// ✅ Storage
export const storage = getStorage(app);

// ✅ Auth - initializeAuth sets persistence upfront, avoiding the queue deadlock
// that happens when setPersistence is called after getAuth in Capacitor WKWebView
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, inMemoryPersistence]
});